import React from 'react';

import useQueryBankAccountStatusesHook from '@fd/customHooks/useQueryBankAccountStatusesHook';
import Grid from '@mui/material/Grid';
import { type Theme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';

const useStyles = makeStyles((theme: Theme) => ({
  paperWrapper: {
    // No palette token matches this amber; kept in sync with DynamicAlertBanner's yellow banner.
    backgroundColor: '#ffbc2c',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down(400)]: {
      paddingTop: theme.spacing(1.25),
    },
  },
}));

type Props = MappedState;

const AlertBankAccountPayoutFailed = (props: Props) => {
  const { currentApp } = props;
  const classes = useStyles();

  const orgId = currentApp?.OrgId ?? '';
  const brandId = currentApp?.AppId ?? '';
  const isFlipdishGlobal = currentApp.AppId === 'flipdish-global';

  // Reuses the same API call and display condition as AlertPayoutFailed (Home page).
  const { hasFailedPayout } = useQueryBankAccountStatusesHook(orgId, brandId, !isFlipdishGlobal);

  if (isFlipdishGlobal || !hasFailedPayout) {
    return null;
  }

  return (
    <Grid container alignItems="center" className={classes.paperWrapper}>
      <Grid item xs={12}>
        <Toolbar>
          <Typography variant="body2" color="textPrimary">
            <Translate id="A_payout_could_not_be_sent_to_your_bank_account_review_affected_account" />
          </Typography>
        </Toolbar>
      </Grid>
    </Grid>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  currentApp: state.currentApp,
});

export default compose<MappedState, Record<string, never>>(connect(mapStateToProps, {}))(
  AlertBankAccountPayoutFailed
);
